import {Component, OnInit} from '@angular/core';
import {CoreService, NavItem} from "libComm";
import {IMenuService} from "libComm";
// import {DDTMenuService} from "../services/DDTMenu.service";

@Component({
	selector: 'menu-side-bar',  // LZ component selector tag

	templateUrl: './MenuSideBar.component.html',

	styleUrls: ['./MenuSideBar.component.scss']
})
export class MenuSideBarComponent implements OnInit
{
	navItems: NavItem[] = [];	// keeps menus items

	// constructor(private menuService: DDTMenuService)
	//constructor(private menuService: IMenuService)
	constructor(private cs: CoreService)
	{
		// console.log("MenuSideBar Component constructor")
	}

	ngOnInit(): void // LZ used for initializing observable and other stuff
	{
		// populate left sidebars menus
		//this.menuService.getMenuItemsObs().subscribe(
		this.cs.getMenuService().getMenuItemsObs().subscribe(
			(items: NavItem[]): void =>
			{
				// console.log(items);
				this.navItems = items;
			}
		)
	}
}
